export const environment = {
  production: true,
  name: 'Quick Pharma - Online Pharmacy Of Bangladesh',
  domain: 'https://quickpharma.com.bd',
  website: 'https://quickpharma.com.bd',

  // apiBaseLink: 'http://localhost:4001',
  // ftpBaseLink: 'http://localhost:4001',

  apiBaseLink: 'https://api.quickpharma.com.bd',
  ftpBaseLink: 'https://api.quickpharma.com.bd',

  // payment page link
  bkashCallbackUrl: 'https://quickpharma.com.bd/payment/check-bkash-payment',

  sslIpnUrl: 'https://api.quickpharma.com.bd/api/payment/ssl-ipn',

  sslSuccessUrl: 'https://api.quickpharma.com.bd/api/payment/callback-success',
  sslFailedUrl: 'https://api.quickpharma.com.bd/api/payment/callback-failed',
  sslCancelUrl: 'https://api.quickpharma.com.bd/api/payment/callback-failed',

  appBaseUrl: '/',
  userBaseUrl: 'account',
  userProfileUrl: '/my-profile',
  userLoginUrl: '/login',
  adminLoginUrl: 'login',
  adminBaseUrl: '/',
  storageSecret: 'SOFT_2021_IT_1998',
  adminTokenSecret: 'SOFT_ADMIN_1995_&&_SOJOL_dEv',
  userTokenSecret: 'SOFT_ADMIN_1996_&&_SOBUR_dEv',
  apiTokenSecret: 'SOFT_API_1998_&&_SAZIB_dEv',
  facebookAppId: '326667463755729',
  googleClientId:
    '403096490255-nf3pgr8jqturvhnhpu5hs8i9vrj4utqh.apps.googleusercontent.com',
  siteKey: '6LeO9XQsAAAAACj1gN9kZB_9R-QLNh-Z6Q7tKBxs',
  VERSION: 2
};
